<template>
  <div>
    <!-- 上方主体 企业服务-->
    <div
      class="container_top"
      id="topCont"
      @mouseover="barNum = 0"
      v-if="contList.picUrl">
      <!-- 轮播图 -->
      <div class="topTitCont">
        <img
          style="width: 100%; display: block"
          :src="contList.picUrl"
          alt="" />
        <div class="cont_topTil">{{ contList.menuName }}</div>
        <div class="cont_topShad">{{ contList.menuNameEn }}</div>
      </div>
      <div class="tapCont">
        <div class="tapAll">
          <div class="tapTxt">
            <div
              v-for="(item, index) in contList.menuModule"
              :key="index"
              class="tapOne"
              :class="tapFlg == index ? 'colr' : ''"
              @click="tapClic(index)">
              {{ item.title }}
            </div>
          </div>
          <div></div>
        </div>

        <div
          :class="
            tapHomeFlg ? 'tapHome' : tapNum == 1 ? 'tapPackUp' : 'tapPack'
          ">
          <div class="memoryTapCont">
            <div class="tapTxt">
              <div
                v-for="(item, index) in contList.menuModule"
                :key="index"
                class="tapOne"
                :class="tapFlg == index ? 'colr' : ''"
                @click="tapClic(index)">
                {{ item.title }}
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>

      <!-- 解决方案 -->
      <div
        class="privateComm"
        id="privateComm"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="priv_compe_tit">{{ contList.menuModule[0].title }}</div>
        <div class="priv_compe_fy">{{ contList.menuModule[0].titleEn }}</div>
        <div class="priv_compe_txt">
          {{ contList.menuModule[0].content }}
        </div>
        <div class="privateCont">
          <div
            class="privLeft"
            @click="
              goEnterprise({
                idNum: '2-1',
                url: 'enterpriseHome/enterpriseMobileSecurity',
                id: contList.menuModule[0].detailsList[0].detailsId,
              })
            ">
            <img
              :src="contList.menuModule[0].detailsList[0].imgUrl"
              alt="" />
            <div class="privBotleft_tit">
              {{ contList.menuModule[0].detailsList[0].title }}
            </div>
            <div class="knowMore">
              了解更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="privRight">
            <div
              class="privRight_top"
              @click="
                goEnterprise({
                  idNum: '2-3',
                  url: 'enterpriseHome/enterpriseMobileOffice',
                  id: contList.menuModule[0].detailsList[1].detailsId,
                })
              ">
              <img
                :src="contList.menuModule[0].detailsList[1].imgUrl"
                alt="" />
              <div class="privBotleft_tit">
                {{ contList.menuModule[0].detailsList[1].title }}
              </div>
              <div class="knowMore">
                了解更多<i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="privRight_bot">
              <div
                class="minLeft"
                @click="
                  goEnterprise({
                    idNum: '2-2',
                    url: 'enterpriseHome/enterpriseMobileComm',
                    id: contList.menuModule[0].detailsList[2].detailsId,
                  })
                ">
                <img
                  :src="contList.menuModule[0].detailsList[2].imgUrl"
                  alt="" />
                <div class="privBotleft_tit">
                  {{ contList.menuModule[0].detailsList[2].title }}
                </div>
                <div class="knowMore">
                  了解更多<i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div
                class="minRIght"
                @click="
                  goEnterprise({
                    idNum: '2-4',
                    url: 'enterpriseHome/enterpriseSmartOffice',
                    id: contList.menuModule[0].detailsList[3].detailsId,
                  })
                ">
                <img
                  :src="contList.menuModule[0].detailsList[3].imgUrl"
                  alt="" />
                <div class="privBotleft_tit">
                  {{ contList.menuModule[0].detailsList[3].title }}
                </div>
                <div class="knowMore">
                  了解更多<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 系统方案 -->
      <div
        class="publicCloud"
        ref="publom"
        id="publicCloud"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="publ_compe_tit">{{ contList.menuModule[1].title }}</div>
        <div class="publ_compe_fy">{{ contList.menuModule[1].titleEn }}</div>
        <div class="publ_compe_txt">
          {{ contList.menuModule[1].content }}
        </div>

        <div class="publCont">
          <!-- <div class="publ_img">
          <img src="@/assets/enterprise/Slice102.png" alt="" />
          <div>企业EMM管理系统</div>
          <div class="knowMore">
            了解更多<i style="color: #048799" class="el-icon-arrow-right"></i>
          </div>
        </div> -->
          <div
            class="publ_img"
            @click="
              goEnterprise({
                idNum: '2-5',
                url: 'enterpriseHome/enterpriseEMM',
                id: contList.menuModule[1].detailsList[0].detailsId,
              })
            ">
            <img
              :src="contList.menuModule[1].detailsList[0].imgUrl"
              alt="" />
            <div>{{ contList.menuModule[1].detailsList[0].title }}</div>
            <div class="knowMore">
              了解更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div
            class="publ_img"
            @click="
              goEnterprise({
                idNum: '2-6',
                url: 'enterpriseHome/enterprisePrivatizationOA',
                id: contList.menuModule[1].detailsList[1].detailsId,
              })
            ">
            <img
              :src="contList.menuModule[1].detailsList[1].imgUrl"
              alt="" />
            <div>{{ contList.menuModule[1].detailsList[1].title }}</div>
            <div class="knowMore">
              了解更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div
            class="publ_img"
            @click="
              goEnterprise({
                idNum: '2-7',
                url: 'enterpriseHome/enterpriseDataSecu',
                id: contList.menuModule[1].detailsList[2].detailsId,
              })
            ">
            <img
              :src="contList.menuModule[1].detailsList[2].imgUrl"
              alt="" />
            <div>{{ contList.menuModule[1].detailsList[2].title }}</div>
            <div class="knowMore">
              了解更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 采购方案 -->
      <div
        class="publicCloud"
        id="groupComm"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="publ_compe_tit">{{ contList.menuModule[2].title }}</div>
        <div class="publ_compe_fy">{{ contList.menuModule[2].titleEn }}</div>
        <div class="publ_compe_txt">
          {{ contList.menuModule[2].content }}
        </div>
        <div class="publCont">
          <div
            class="publ_img"
            @click="
              goEnterprise({
                idNum: '2-8',
                url: 'enterpriseHome/enterpriseProcurement',
                id: contList.menuModule[2].detailsList[0].detailsId,
              })
            ">
            <img
              :src="contList.menuModule[2].detailsList[0].imgUrl"
              alt="" />
            <div>{{ contList.menuModule[2].detailsList[0].title }}</div>
            <div class="knowMore">
              了解更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="mobile">
      <enterpriseHome :contList="contList" />
    </div>
  </div>
</template>

<script>
import enterpriseHome from '@/views/mobile/enterpriseService/enterpriseHome.vue';
import { getCategoryInfo } from '@/api/index';
export default {
  props: { switchNum: String },
  components: { enterpriseHome },
  data() {
    return {
      tapHomeFlg: false,
      tapNum: 0,
      tapFlg: '0',
      contList: {},
    };
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      if (curVal == 3) {
        document
          .getElementById('topCont')
          .scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    if (this.switchNum == 3) {
      document.getElementById('topCont').scrollIntoView({ behavior: 'smooth' });
    }
    if (this.getID(this.$route.name, this.$store.state.treeList)) {
      localStorage.setItem(
        'menuId',
        this.getID(this.$route.name, this.$store.state.treeList).id
      );
    }
    this.flgId = localStorage.getItem('menuId');

    console.log(
      localStorage.getItem('menuId'),
      this.getID(this.$route.name, this.$store.state.treeList),
      'ces缩放'
    );
    if (this.getID(this.$route.name, this.$store.state.treeList)) {
      localStorage.setItem(
        'menuId',
        this.getID(this.$route.name, this.$store.state.treeList).id
      );
    }
    if (this.flgId) {
      getCategoryInfo(this.flgId).then((res) => {
        this.contList = res.data.data;
        console.log(this.contList);
      });
    }
  },
  methods: {
    // 回调函数
    getID(name, list) {
      let _this = this;
      for (let item of list || []) {
        if (item.routingPath == name) return item;
        const sum = _this.getID(name, item.children);
        if (sum) return sum;
      }
    },
    tapClic(row) {
      console.log(row);
      this.tapFlg = row;
      if (row == 0) {
        document
          .getElementById('privateComm')
          .scrollIntoView({ behavior: 'smooth' });
      }
      if (row == 1) {
        document
          .getElementById('publicCloud')
          .scrollIntoView({ behavior: 'smooth' });
      }
      if (row == 2) {
        document
          .getElementById('groupComm')
          .scrollIntoView({ behavior: 'smooth' });
      }
      if (row == 4) {
        document
          .getElementById('enterpriseMob')
          .scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleScroll() {
      if (this.$refs.publom && this.$refs.publom.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.publom.offsetTop,
        //   this.switchNum
        // );
        if (window.scrollY > 850) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        this.$emit('switchflg', '0');
      }
    },
    // // 回调函数
    // getID(name, list) {
    //   let _this = this;
    //   for (let item of list || []) {
    //     if (item.label == name) return item;
    //     const sum = _this.getID(name, item.children);
    //     if (sum) return sum;
    //   }
    // },
    goEnterprise(row) {
      this.$router.push({
        name: row.url,
        params: { id: row.id },
      });
      this.$store.commit('changeTabCheck', {
        idNum: row.idNum,
        sumName: '',
      });
      this.$store.state.enterp_somFlg = '';
    },
  },
};
</script>

<style lang="less" scoped>
.container_top {
  width: 100%;
  .topTitCont {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    //left: 13%;
    font-size: 46px;
    font-weight: 600;
    color: white;
  }
  .cont_topShad {
    opacity: 0.8;
    position: absolute;
    bottom: 45%;
    //left: 13%;
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    font-size: 22px;
    color: white;
  }
}

// 头部tap
.tapCont {
  position: relative;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .tapAll {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tapTxt {
    display: flex;
    align-items: center;
    margin-left: -20px;
  }
  .tapOne {
    cursor: pointer;
    cursor: pointer;
    font-size: 20px;
    margin: 20px;
  }
  .colr {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    position: relative;
    color: #048799;
  }
  .colr::before {
    content: '';
    height: 3px;
    background: #048799;
    position: absolute;
    top: 44px;
    width: 100%;
  }
  @keyframes arise {
    0% {
      top: -80px;
    }
    100% {
      top: 0px;
    }
  }
  .memoryTapCont {
    width: 100%;
    max-width: 1200px;
  }

  .tapHome {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 103px;
    animation: arise 0.5s ease-out;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .tapPackUp {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
    animation: packUp 0.5s ease-out;
  }
  @keyframes packUp {
    0% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: 0px;
    }
    100% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: -80px;
    }
  }
  .tapPack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
  }
}

// 解决方案
.publicCloud {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // padding: 60px 10px;
  margin-top: 100px;
  .publ_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 10px;
  }
  .publ_compe_tit::before {
    content: '';
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 46px;
    width: 100%;
  }

  .publ_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .publ_compe_txt {
    font-size: 20px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    margin-top: 80px;
  }
  .publCont {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin: 80px;
    // width: 1200px;
    width: 100%;
    max-width: 1230px;
    margin: 0 auto;
    margin-top: 80px;
    // width: 1462px;
  }
  .publ_img {
    margin: 0 15px;
    position: relative;

    overflow: hidden;
    // height: 318px;
  }
  .publ_img::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }
  .publ_img img {
    display: block;
    cursor: pointer;
    transition: ease all 0.3s;
    width: 100%;
    // width: 380px;
    // height: 240px;
  }
  .publ_img:hover img {
    transform: scale(1.1);
  }

  .publ_img:hover div {
    display: block;
    bottom: 45px !important;
  }
  .publ_img div {
    cursor: pointer;
    position: absolute;
    transition: all 0.3s ease-in-out;
    bottom: 20px;
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    z-index: 2;
  }
  .publ_img:hover .knowMore {
    bottom: 20px !important;
    // height: 0px;
    opacity: 1;
    // display: flex;
    // justify-content: center;
    // align-content: center;
  }
  .knowMore {
    // display: flex;
    // justify-content: center;
    // align-content: center;
    // display: none;
    // transition: all 0.3s ease-in-out;
    // bottom: -65px !important;
    position: absolute;
    // height: 0;
    color: #fff;
    font-size: 16px !important;
    margin-left: 30px;
    transition: ease all 0.3s;
    bottom: -10px !important;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }

  .publLeft {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .publ_text_Cont {
    width: 55%;
    line-height: 32px;
  }
  .publ_tit {
    font-size: 21px;
    font-weight: 500;
    color: #151a23;
    line-height: 70px;
  }
  .publRight {
    width: 50%;
  }
}
// .privateCommUrl {
//   width: 100%;
//   max-width: 1200px;
//   margin: 20px;
//   display: flex;
//   justify-content: center;
// }
// 系统方案
.privateComm {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // padding: 100px 26px;
  margin-top: 100px;

  .priv_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 10px;
  }
  .priv_compe_tit::before {
    content: '';
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 46px;
    width: 100%;
  }

  .priv_compe_txt {
    font-size: 20px;
    margin: 80px 0;
    width: 100%;
    max-width: 1200px;
    // margin: 0 auto;
    text-align: center;
  }
  .priv_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }

  .privateCont {
    display: flex;
    justify-content: center;
    align-items: self-start;
    // margin: 80px;

    // width: 1200px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    // width: 1462px;
  }
  .privateCont img {
    width: 100%;
    transition: ease all 0.3s;
    cursor: pointer;
    display: block;
  }
  // .privateCont img:hover {
  //   transform: scale(1.1);
  // }
  .privRight_top img {
    width: 770px;
    height: 240px;
  }
  .privRight_top:hover img {
    transform: scale(1.1);
  }
  .privRight_top:hover {
    .knowMore {
      height: 40px;
      opacity: 1;
    }
  }
  .privRight_top:hover {
    .privBotleft_tit {
      bottom: 45px;
    }
  }
  .privLeft:hover img {
    transform: scale(1.1);
  }
  .privLeft:hover {
    .knowMore {
      height: 40px;
      opacity: 1;
    }
  }
  .privLeft:hover {
    .privBotleft_tit {
      bottom: 45px;
    }
  }

  .privLeft {
    // position: relative;
    // margin-right: 30px;
    // height: 480px;
    position: relative;
    overflow: hidden;
    // height: 570px;
  }

  .privLeft_tit {
    position: absolute;
    bottom: 40px;
    left: 40px;
    font-size: 20px;
    color: #fff;
  }
  .privRight {
    // display: grid;
    // grid-template-rows: repeat(2, 1fr);
    // align-items: self-end;

    margin-left: 30px;
  }
  .privRight_top {
    // position: relative;
    position: relative;
    overflow: hidden;
    // height: 235px;
    margin-bottom: 30px;
  }
  .privRight_top::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }
  .privRight_cont img {
    margin-bottom: 37px;
  }
  .privRight_tit {
    position: absolute;
    top: 77%;
    left: 40px;
    font-size: 20px;
    color: #fff;
  }

  .privRight_bot {
    display: flex;
    // justify-content: space-between;
    position: relative;
    // margin-top: 2.9%;

    // margin-top: 27px;
  }
  .privRight_bot img {
    // width: 100%;
    width: 370px;
    height: 240px;
  }
  .minLeft {
    position: relative;
    overflow: hidden;
    // height: 210px;
    margin-right: 15px;
  }
  .minLeft::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }
  .minLeft img {
    width: 370px;
    height: 240px;
  }
  .minLeft:hover img {
    transform: scale(1.1);
  }
  .minLeft:hover {
    .knowMore {
      height: 40px;
      opacity: 1;
    }
  }
  .minLeft:hover {
    .privBotleft_tit {
      bottom: 45px;
    }
  }
  .minRIght {
    position: relative;
    overflow: hidden;
    // height: 210px;
    margin-left: 15px;
  }
  .minRIght::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }
  .minRIght img {
    width: 370px;
    height: 240px;
  }
  .minRIght:hover img {
    transform: scale(1.1);
  }
  .minRIght:hover {
    .knowMore {
      height: 40px;
      opacity: 1;
    }
  }
  .minRIght:hover {
    .privBotleft_tit {
      bottom: 45px;
    }
  }
  .privBotleft_tit {
    position: absolute;
    bottom: 20px;
    left: 20px;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
    transition: ease all 0.3s;
    z-index: 2;
  }
  .knowMore {
    position: absolute;
    height: 0;
    color: #fff;
    font-size: 16px;
    margin-left: 20px;
    transition: ease all 0.3s;
    bottom: 0px !important;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }
  .privLeft {
    img {
      height: 510px;
    }
  }
  .privLeft::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }

  .privBotright_tit {
    position: absolute;
    bottom: 30px;
    right: 22%;
    font-size: 20px;
    color: #fff;
  }
}

//企业移动办公安全解决方案
.ente_compe_fy {
  font-size: 20px;
  margin: 40px 0;
  width: 65%;
  text-align: center;
}
</style>
<style lang="scss" scoped>
@import '@/assets/variables.scss';
@media (max-width: $ipad-max-size) {
  #topCont {
    display: none;
  }
  #mobile {
    display: block !important;
  }
}
#mobile {
  display: none;
}
</style>
